import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Messages } from '../../notifications/constants/messages';
import { MatDialog } from '@angular/material/dialog';
import { IDialogTimeoutModel } from 'src/app/modules/account/interfaces/dialog-model';
import { ServerUnavailableComponent } from 'src/app/modules/maintenance/components/server-unavailable/server-unavailable.component';
import { TimeoutErrorComponent } from 'src/app/modules/maintenance/components/timeout-error/timeout-error.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  isServerModalOpen = false;
  isTimeoutModalOpen = false;

  constructor(
    private _dialog: MatDialog,
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        switch (true) {
          case (error instanceof TimeoutError):{
            const timeoutError: IDialogTimeoutModel = {
              message: Messages.timeoutError,
              response: false
            };
            this.openTimeoutErrorModal(timeoutError);
            return throwError(Messages.timeout);
          }
          case (error.statusText === 'Unknown Error'):
          case (error.status === 0):{
            const unknownError: IDialogTimeoutModel = {
              message: Messages.conexionError,
              response: false
            };
            this.openTimeoutErrorModal(unknownError);
            return throwError(Messages.conexionError);
          }
          default:
            this.checkIfServiceIsAvailable(error);
            return throwError(error);
        }
      })
    );
  }

  checkIfServiceIsAvailable(error: HttpErrorResponse) {
    if (error instanceof HttpErrorResponse && error.status !== 401 && error?.error?.Message && error.error.Message.Content.startsWith('Temporalmente fuera de servicio')) {
      this.openServiceUnavailableModal(error);
    }
  }

  openServiceUnavailableModal(error: HttpErrorResponse) {
    if (!this.isServerModalOpen) {
      this.isServerModalOpen = true;
      const dialog = this._dialog.open(ServerUnavailableComponent, {
        minWidth: '300px',
        width: '50%',
        data: error.error.Message.Content
      });
      dialog.afterClosed().subscribe(() => {
        this.isServerModalOpen = false;
      });
    }
  }

  openTimeoutErrorModal(error: IDialogTimeoutModel) {
    if (!this.isTimeoutModalOpen) {
      this.isTimeoutModalOpen = true;
      const dialog = this._dialog.open(TimeoutErrorComponent, {
        minWidth: '300px',
        width: '50%',
        data: error
      });
      dialog.afterClosed().subscribe(() => {
        this.isTimeoutModalOpen = false;
      });
    }
  }
}
